import * as React from "react";
const SvgRemoveFore = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.9795 4C13.5576 4 14 4.47641 14 5.02051V11.9795C14 12.5236 13.5236 13 12.9795 13H12.6807L7.48438 4H12.9795ZM4.02051 4L9.2168 13H3.02051C2.44241 13 2 12.5236 2 11.9795V5.02051C2 4.44241 2.44241 4 3.02051 4H4.02051Z", fill: "#666666", style: {
  fill: "#666666",
  fill: "color(display-p3 0.4000 0.4000 0.4000)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { x: 3.23926, y: 2.91422, width: 1.4993, height: 13.659, rx: 0.5, transform: "rotate(-30 3.23926 2.91422)", fill: "#666666", style: {
  fill: "#666666",
  fill: "color(display-p3 0.4000 0.4000 0.4000)",
  fillOpacity: 1
} }));
export default SvgRemoveFore;
